module.exports = __webpack_public_path__ + "static/1-hover-08be2a186510448828d00f58a6145005.png";